import React from 'react'
import { getHexColor } from "./common/color_utils";

export default class DarkModeToggle extends React.Component {
  constructor(props) {
    super(props)

    if (JSON.parse(localStorage.getItem('DARK_MODE')) === true) {
      document.body.classList.add('dark-mode')
    }

    this.state = {
      darkMode: JSON.parse(localStorage.getItem('DARK_MODE')),
    }

    this.handleModeChange = this.handleModeChange.bind(this)
  }

  handleModeChange() {
    if (!this.state.darkMode) {
      document.body.classList.add('dark-mode')
    } else {
      document.body.classList.remove('dark-mode')
    }

    this.setState({
      darkMode: !this.state.darkMode,
    })
    localStorage.setItem('DARK_MODE', !this.state.darkMode)
    this.updateStylesManually();
  }

  render() {
    return (
      <div className="mode-btn">
        <button
          className="dark-mode-button"
          onClick={this.handleModeChange}
        >
          Switch Mode
        </button>
      </div>
    )
  }

  updateStylesManually() {
    try {
      const root = document.documentElement;
      root.style.setProperty("--brand-color", getHexColor());
    } catch (e) { }
  }
}



// WEBPACK FOOTER //
// ./src/components/DarkModeToggle.js